import { RootState } from "../index";
import { BasketItem } from "../slices/basketSlice";

export const getBasketItemUnitPrice = (item: BasketItem) => {
  const storedPrice = Number(item.total_price) || 0;
  const basePrice = Number(item.org_price) || 0;
  const modifierPrice = (item.selectedModifiers ?? []).reduce(
    (total, modifier) =>
      total + (Number(modifier.price) || 0) * modifier.quantity,
    0,
  );

  return Math.max(storedPrice, basePrice + modifierPrice);
};

export const selectTotalQuantity = (state: RootState) =>
  state.basket.items
    .filter((item) => item.isAvailable)
    .reduce((total, item) => total + item.quantity, 0);

export const selectTotalPrice = (state: RootState) =>
  state.basket.items
    .filter((item) => item.isAvailable)
    .reduce(
      (total, item) => total + getBasketItemUnitPrice(item) * item.quantity,
      0,
    );

export const selectBasketItems = (state: RootState) => state.basket.items;

export const selectBasketCalculation = (state: RootState) => ({
  isCalculatingCart: state.basket.isCalculatingCart,
  calculatedSubtotalPrice: state.basket.calculatedSubtotalPrice,
  calculatedDeliveryPrice: state.basket.calculatedDeliveryPrice,
  calculatedTotalPrice: state.basket.calculatedTotalPrice,
  appliedPromotions: state.basket.appliedPromotions,
  earnedAmount: state.basket.earnedAmount,
  availableAmountForCurrentOrder: state.basket.availableAmountForCurrentOrder,
  availablePoints: state.basket.availablePoints,
  pointsEnabled: state.basket.pointsEnabled,
  bonusPaymentPercent: state.basket.bonusPaymentPercent,
  selectedBonusPay: state.basket.selectedBonusPay,
  promoValidationStatus: state.basket.promoValidationStatus,
  couponStatus: state.basket.couponStatus,
  promoCode: state.basket.promoCode,
  activePromoCode: state.basket.activePromoCode,
});

/** Применённый промокод (см. basketSlice.promoCode) — для отметки в списке. */
export const selectAppliedPromoCode = (state: RootState) =>
  state.basket.promoCode;
